import Axios from "axios";

export default class Localizer {
    static cultureResources: Map<string, any> = new Map<string, any>();
    static defaultCulture: string | null = null;

    static async init(configuration: LocalizerConfiguration) {
        this.defaultCulture = configuration.defaultCulture;

        configuration.resourceCultures = configuration.resourceCultures ?? [configuration.defaultCulture];

        const responses = await Promise.all(configuration.resourceCultures.map(resourceCulture =>
            Axios.get("/localization/resource/getresources", { params: { culture: resourceCulture, contexts: configuration.resourceContexts.join(",") } })));

        configuration.resourceCultures.forEach((resourceCulture, index) => this.cultureResources.set(resourceCulture, responses[index].data));
    }

    static get(name: string, ...values: any[]): string {
        return this.getByCulture(name, this.defaultCulture, ...values);
    }

    static getByCulture(name: string, culture: string | null, ...values: any[]): string {
        const placeHolder = name.split(".").pop() ?? name;

        let resources: any = this.cultureResources.get(culture ?? "");

        if (!resources) {
            // Culture not found
            return placeHolder;
        }

        if (resources[name] == null || resources[name] === '') {
            return placeHolder;
        }

        const resource: string = resources[name];

        return resource.replace(/\{(\d+)\}/g, (match, indexText) => {
            const index = Number(indexText);
            return index < values.length ? String(values[index]) : match;
        });
    }
}

export interface LocalizerConfiguration {
    defaultCulture: string;
    resourceContexts: string[];
    resourceCultures?: string[];
}